import { FC } from 'react';

import { FormControl, Select, MenuItem } from '@mui/material';

import { UseFormRegisterReturn } from 'react-hook-form';

import { SelectableArray } from '@type-def_common/SelectableArray';

import styles from './SelectBoxWrapper.module.scss';

type Props = {
  placeholder: string;
  selectList: SelectableArray;
  state: string | null | undefined;
  setState: React.SetStateAction<any>;
  onChangeFunction?: any;
  size?: string;
  classNames?: string;
  disabled?: boolean;
  dataTestId?: string;
  defaultValue?: string;
  refValidation?: UseFormRegisterReturn;
};

const SelectBoxWrapper: FC<Props> = ({
  placeholder,
  selectList,
  state,
  setState,
  onChangeFunction,
  size,
  classNames,
  disabled,
  dataTestId,
  defaultValue,
  refValidation,
}) => {
  if (state === null) {
    state = '';
  }
  const handleSelect = (event: any) => {
    if (onChangeFunction) {
      onChangeFunction(event);
    } else {
      const {
        target: { value },
      } = event;
      setState(value);
    }
  };

  const disableClassName = Object.keys(selectList).length > 0 ? '' : styles.is_disable;
  return (
    <FormControl>
      <Select
        disabled={disabled}
        displayEmpty
        {...refValidation}
        value={state}
        onChange={(event) => {
          refValidation && refValidation.onChange(event);
          handleSelect(event);
        }}
        label={placeholder}
        renderValue={(value) => (value ? selectList[value] : <span className={styles.placeholder}>{placeholder}</span>)}
        className={`${styles.select} ${disableClassName}  ${size === 'width1' && 'util-formWidth1'} 
            ${size === 'width2' && 'util-formWidth2'} ${classNames}`}
        data-testid={dataTestId}
        defaultValue={defaultValue}
      >
        {Object.keys(selectList).map((key) => (
          <MenuItem className={styles.menu_item} key={key} value={key}>
            {selectList[key]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectBoxWrapper;
